import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import BackButton from '@/components/BackButton.vue';
const backgroundModule = namespace('backgrounds');
const skills = [
    'Athletics',
    'Acrobatics',
    'Sleight of Hand',
    'Stealth',
    'Investigation',
    'Lore',
    'Nature',
    'Piloting',
    'Technology',
    'Animal Handling',
    'Insight',
    'Medicine',
    'Perception',
    'Survival',
    'Deception',
    'Intimidation',
    'Performance',
    'Persuasion'
];
let CharactersBackgrounds = class CharactersBackgrounds extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = this.isInHandbook ? 'Backgrounds | Handbook' : 'Backgrounds';
    }
    created() {
        this.fetchBackgrounds();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        const page = this.isInHandbook ? 'rules/phb' : 'characters';
        return _(this.backgrounds)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(background => ({
            ...background,
            to: `/${page}/backgrounds/${background.name}`
        })).value();
    }
    get headers() {
        return [
            {
                text: 'Name',
                value: 'name'
            },
            {
                text: 'Skill Proficiency',
                value: 'skillProficiencies',
                isMultiSelect: true,
                filterChoices: skills,
                filterFunction: ({ skillProficiencies }, filterValue) => filterValue.every(skill => skillProficiencies.includes(skill))
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: this.isInHandbook ? ['PHB'] : ['PHB', 'EC'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    backgroundModule.State
], CharactersBackgrounds.prototype, "backgrounds", void 0);
__decorate([
    backgroundModule.Action
], CharactersBackgrounds.prototype, "fetchBackgrounds", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharactersBackgrounds.prototype, "isInHandbook", void 0);
CharactersBackgrounds = __decorate([
    Component({
        components: {
            BackButton,
            SearchTable
        }
    })
], CharactersBackgrounds);
export default CharactersBackgrounds;
